export default __webpack_public_path__ + "e6f4e254e8b705435dd6567ae743186c.woff2";